import { WriteYourQuestion } from "../MyInquiry/WriteYourQuestion";

export const HomeMyInquiry = () => {
  return (
    <div className="mx-auto mb-0 mt-10 flex h-auto lg:h-[21.25rem] flex-col sm:flex-row flex-nowrap sm:mb-[4.5rem] sm:mt-[4.5rem] sm:flex-nowrap">
      <WriteYourQuestion />
    </div>
  );
};
